module.exports = __webpack_public_path__ + "static/media/delta.a6b1b08c.png";